<template>
  <div class="strategy-tab"
       :class="{'strategy-tab__print': isStaticView}">
    <div v-if="briefContent.name !== ''" class="strategy-tab__container">
      <div class="strategy-tab__row">
        <!-- <base-content-block
          :headerStyle="{'display': 'none'}"
        > -->
          <ResponseCodeBlock v-if="briefContent.state_initial_response_code"
            :state_initial_response_code="briefContent.state_initial_response_code"
            :state_initial_response_url="briefContent.state_initial_response_url"
            :state_initial_response_code_published="briefContent.state_initial_response_code_published"
            :state_initial_response_url_published="briefContent.state_initial_response_url_published"
          />
        <!-- </base-content-block> -->
      </div>

      <div class="strategy-tab__row strategy-tab__row_extended ">
        <BaseCollapsibleBlock :title="'Content Elements'"
                            class="strategy-tab__content-elements"
                            v-model="isKeywordsCloudCollapsed"
                            :isStaticView="isStaticView">
          <ContentElements
            isSimplifiedView
            hideFields
            showRecommendedField
            :content="briefContent"
            @apply="updateContentBrief" />
        </BaseCollapsibleBlock>
        <BaseCollapsibleBlock :title="'Keyword Cloud'"
                              class="strategy-tab__keyword-cloud"
                              v-model="isKeywordsCloudCollapsed"
                              :isStaticView="isStaticView"
                              ref="keyword-cloud"
        >
          <keyword-cloud/>
        </BaseCollapsibleBlock>
      </div>

      <BaseCollapsibleBlock :title="'Strategy Notes'"
                            :isCollapsed="false"
                            :isStaticView="isStaticView">
        <template #header-additional>
          <div class="strategy-tab__edit-wrapper" v-if="!isCurrentUserClientCollaborator">
            <div @click.stop="openEditorModal('summary')" class="strategy-tab__edit">
              <base-material-design-icon icon="edit" class="strategy-tab__edit-icon"/>
            <span class="strategy-tab__edit-label">Edit</span>
            </div>
          </div>

        </template>
        <HtmlRendererComponent :content="briefContent.summary || ''"/>
      </BaseCollapsibleBlock>

      <BaseCollapsibleBlock :title="'Content Notes'"
                            :isCollapsed="false"
                            :isStaticView="isStaticView">
        <template #header-additional>
          <div class="strategy-tab__edit-wrapper">
            <div @click.stop="openEditorModal('content')" class="strategy-tab__edit">
              <base-material-design-icon icon="edit" class="strategy-tab__edit-icon"/>
            <span class="strategy-tab__edit-label">Edit</span>
            </div>
          </div>

        </template>
        <HtmlRendererComponent :content="briefContent.content || ''"/>
      </BaseCollapsibleBlock>

      <Keywords :keywords="keywords"
                :isStaticView="isStaticView"
                :isKeywordsPresent="isKeywordsPresent"
                @update-score="$emit('update-score', $event)"/>

    </div>
    <div v-if="isDataUpdating" class="strategy-tab__update-loader">
        <base-loader class="strategy-tab__update-loader-ring"/>
    </div>
    <div class="strategy-tab__editor-container__wrapper"
        :class="{'strategy-tab__editor-container__wrapper-drag': editorDrag}"
        v-if="isEditorOpened">
      <VueDraggableResizable
        :draggable="activeResizable"
        ref="editor"
        @dragging="changeDragging(true)"
        @dragstop="changeDragging(false)"
        classNameResizing="strategy-tab__resizing"
        class-name="strategy-tab__editor-container"
        :class="{'strategy-tab__editor-resize-disabled': !activeResizable}"
        :parent="true"
        :h="490"
        :min-height="250"
        :min-width="500"
      >
        <ContentNotesEditor class="strategy-tab__editor"
                            :class="{'strategy-tab__editor-drag': editorDrag}"
                            ref="contentNotesEditor"
                            :editorField="editorField"
                            @changeCollapsed="changeCollapsed"
                            @close="closeEditorModal(false)"
                            @apply="onApplyEditor"/>
      </VueDraggableResizable>
    </div>
    <modal name="confirm-modal" v-bind="modalProps">
     <base-confirm-modal title="You have unsaved changes!"
                         yesText="Save changes and close"
                         yesBtnColor="#2d3e4c"
                         noText="Discard changes and close"
                         @confirm="closeEditorModal"/>
   </modal>
  </div>
</template>

<script>
/* eslint-disable no-unused-vars */

import { mapActions, mapState } from 'vuex'
import Keywords from './Keywords'
import ResponseCodeBlock from './ResponseCodeBlock'
import HtmlRendererComponent from './HtmlRendererComponent'
import VueDraggableResizable from 'vue-draggable-resizable'
// import ContentElements from './ContentElements'
import KeywordCloud from './KeywordCloud'
import ContentNotesEditor from './ContentNotesEditor'
import ContentBrief from './index'
import baseModalProps from '@/common/BaseModalProps'
import _ from 'lodash'
import ContentElements from './ContentElements.vue'
/**
 * Strategy tab. Used in {@link ContentBrief}
 */
export default {
  name: 'StrategyTab',

  props: {
    isStaticView: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    return {
      isEditorOpened: false,
      link: document.location.href,
      sortedSnapshots: [],
      isDataUpdating: false,
      activeResizable: true,
      editorDrag: false,
      editorField: null,
      
      isAttachmentsCollapsed: false,
      editorCollapsedState: false,
      isKeywordsCloudCollapsed: false,
    }
  },
  components: {
    Keywords,
    ResponseCodeBlock,
    ContentNotesEditor,
    KeywordCloud,
    ContentElements: () => import('./ContentElements'),
    HtmlRendererComponent,
    VueDraggableResizable
  },
  computed: {
    ...mapState({
      isNavbarCollapsed: 'isNavbarCollapsed'
    }),
    ...mapState('briefContent', [
      'briefContent'
    ]),
    ...mapState({
      userEmail: state => {
        return state.currentUser ? state.currentUser.email : ''
      },
      clients: 'clients',
      selectedClient: 'selectedClient'
    }),
    modalProps () {
      return { ...baseModalProps, height: 'auto', width: '510px' }
    },
    briefId () {
      return this.$route.params.id
    },
    isKeywordsPresent () {
      return !!(this.briefContent.keywords && this.briefContent.keywords.length)
    },
    keywords () {
      return this.briefContent.keywords
    },
  },
  methods: {
    ...mapActions('briefContent', [
      'getBriefContent',
      'getComments',
      'changeContentBrief'
    ]),
    /**
     * get content brief data
     * used only after updating content brief
     */
    async getData () {
      try {
        await this.getBriefContent({
          briefId: this.briefContent._id,
          reset: false,
          clientId: this.clientId
        })
      } catch {
        this.$router.replace('/strategy/url-planner')
        return
      }
      this.getComments({ briefId: this.briefContent._id })
    },
    /**
     * opens content notes editor modal
     */
    openEditorModal (field) {
      if (this.isEditorOpened) {
        return
      }
      this.editorField = field
      this.isEditorOpened = true
      this.activeResizable = true
      // set initial state for editor
      this.$nextTick(() => {
        this.$refs.editor.$el.setAttribute('style', `top:calc(100vh - ${this.$refs.editor.h / 2}px); left:130px; width: calc(100vw - 130px); height: 490px;`)
        this.$refs.editor.x = 130
        this.$refs.editor.y = this.$refs.editor.$el.offsetTop
        this.$refs.editor.w = this.$refs.editor.$el.offsetWidth
      })
      // // scrolls keyword cloud block at the top of visible area
      // setTimeout(() => {
      //   const element = this.$refs['keyword-cloud']
      //   element && element['$el'].scrollIntoView({ block: 'start', behavior: 'smooth' })
      // }, 1000)
    },
    tryCloseEditorModal (payload) {
      this.editorPayload = payload
      const initialPayload = this.$refs.contentNotesEditor.initialPayload
      if (!_.isEqual(initialPayload, payload)) {
        this.editorCollapsedState = this.$refs.contentNotesEditor.isCollapsed
        this.$refs.contentNotesEditor.isCollapsed = true
        this.changeCollapsed(true)
        this.$modal.show('confirm-modal')
      } else {
        this.closeEditorModal(true)
      }
    },
    closeEditorModal (status) {
      this.$modal.hide('confirm-modal')
      const initialPayload = this.$refs.contentNotesEditor.initialPayload
      const isEditorDirty = !_.isEqual(initialPayload, this.editorPayload)
      if (status) {
        isEditorDirty && this.onApplyEditor(this.editorPayload)
        this.editorDrag = false
        this.isEditorOpened = false
      } else {
        // this.$refs.contentNotesEditor.isCollapsed = this.editorCollapsedState
        // this.changeCollapsed(this.editorCollapsedState)
        this.editorDrag = false
        this.isEditorOpened = false
      }
    },
    updateContentBrief: async function (payload, silentMode = false) {
      try {
        // this.isDataUpdating = true
        await this.changeContentBrief({ ...payload, silentMode})
        return true
        // await this.getData()
        // this.isDataUpdating = false
      } catch (e) {
        return false
        // this.isDataUpdating = false
      }
    },
    /**
     * callback inviked by updating content brief notes
     */
    async onApplyEditor ({ payload, silentMode }) {
      this.editorPayload = payload
      // this.closeEditorModal()
      const updated = await this.updateContentBrief(payload, silentMode)
      // if (updated) {
      //   this.$refs.contentNotesEditor.resetUndo()
      // }
    },
    changeDragging (state) {
      this.editorDrag = state
    },
    
    changeCollapsed (isCollapsed) {
      this.activeResizable = !isCollapsed
      if (isCollapsed) {
        // collapse and move to the bottom - right
        this.$refs.editor.$el.setAttribute('style', `top:calc(100vh - 250px);
                                                     left:calc(100vw - 520px);
                                                     position:absolute;
                                                     width: 500px;
                                                     height: 250px;
                                                     transition-duration: 1s;`)
      } else {
        // return to previous state
        this.$refs.editor.$el.setAttribute('style', `top:${this.$refs.editor.top}px;
                                                     left:${this.$refs.editor.left}px;
                                                     position:absolute;
                                                     width: ${this.$refs.editor.width}px;
                                                     height: ${this.$refs.editor.height}px;
                                                     pointer-events: none;
                                                     transition-duration: 1s;`)
        setTimeout(() => {
          // remove animation and enable drag-n-drop
          this.$refs.editor.$el.setAttribute('style', `top:${this.$refs.editor.top}px;
                                                     left:${this.$refs.editor.left}px;
                                                     position:absolute;
                                                     width: ${this.$refs.editor.width}px;
                                                     height: ${this.$refs.editor.height}px;`)
        }, 1000)
      }
    }
  }
}

</script>

<style scoped lang="scss">

  .hide {
    display: none;
  }

  .highlight-msg-icon {
    color: $rfx-bright-turquoise;
  }

  .strategy-tab {
    &__row {
      display: flex;

      &_extended {
        gap: 14px;
      }
    }

    &__content-elements,
    &__keyword-cloud {
      flex: 0 0 calc(50% - 7px);
      width: calc(50% - 7px) !important;
    }

    &__attachments {
      flex: 0 0 37%;
      max-width: 37%;
    }

    &__edit {
      cursor: pointer;
      display: flex;
    align-items: center;

      &-wrapper {
        margin-left: 6px;
        width: 100%;
        display: flex;
        justify-content: flex-end;
        align-items: center;
      }

      &-icon {
        color: $rfx-bright-blue;
        font-size: 24px;
      }

      &-label {
        margin-left: 5px;
        color: $rfx-bright-blue;
      }
    }

    &__container {
      min-width: 964px;
    }

    &__loader {
      display: flex;
      width: 100%;
      justify-content: center;
      height: calc(100vh - 530px);
      align-items: center;
    }

    &__update-loader {
      position: fixed;
      display: flex;
      width: 100%;
      height: 100%;
      justify-content: center;
      background-color: white;
      top: 0;
      left: 0;
      opacity: 0.5;
      z-index: 10000;
    }

    &__update-loader-ring {
      margin-top: 300px;
    }

    &__editor-container__wrapper {
      z-index: 1000;
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      pointer-events: none;
      user-select: none;
    }

    &__editor-container__wrapper-drag {
      pointer-events: all !important;
    }

    &__editor-resize-disabled {
      &::v-deep .handle {
        pointer-events: none !important;
        cursor: default !important;
      }
    }

    &__resizing {

      .strategy-tab__editor {
        pointer-events: none !important;
        user-select: none !important;
      }
    }

    &__editor-container {
      background-color: #fff;
      box-shadow: 0 0 10px 27px rgba(0,0,0,0.1);;
      z-index: 999;
      pointer-events: all;

      &_shifted {
        width: 78vw;
        margin-left: 100px;
      }

      &::v-deep .handle {
        position: absolute;
        z-index: 1000;
        display: block !important;
      }

      &::v-deep .handle-tm {
        height: 6px;
        width: 98.6%;
        left: 6px;
        cursor: ns-resize;
      }

      &::v-deep .handle-bm {
        height: 6px;
        width: 98.6%;
        left: 6px;
        cursor: ns-resize;
        bottom: 0;
      }

      &::v-deep .handle-tl {
        height: 12px;
        width: 6px;
        cursor: nwse-resize;
      }

      &::v-deep .handle-bl {
        height: 12px;
        width: 6px;
        cursor: nesw-resize;
        bottom: 0;
      }

      &::v-deep .handle-tr {
        right: 0;
        height: 12px;
        width: 6px;
        cursor: nesw-resize;
      }

      &::v-deep .handle-br {
        right: 0;
        height: 12px;
        width: 6px;
        bottom: 0;
        cursor: nwse-resize;
      }

      &::v-deep .handle-ml, .handle-mr {
        top: 12px;
        height: 95.2%;
        width: 6px;
        cursor: ew-resize;
      }

      &::v-deep .handle-mr {
        right: 0;
      }
    }

    &__editor {

    }
    &__editor-drag {
      pointer-events: none;
      user-select: none;

      &::v-deep .content-notes-editor__wrapper {
        user-select: none !important;
      }
    }
    &__not-found {
      font-size: 27px;
      font-weight: 600;
      display: flex;
      align-items: center;
      justify-content: center;
      height: 60px;
      color: $rfx-medium-grey;
    }
  }

  .strategy-tab__print {
    padding-bottom: 0;

    .container {
      width: calc(100% - 60px);
    }
  }

  @media print {
    @page {
      margin: 0;
      size: auto;
    }
  }
</style>
